<template>
  <div class="payment-method-component">
    <div class="column is-8-desktop is-10-tablet is-12-mobile is-offset-2-desktop is-offset-1-tablet is-offset-0-mobile">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Qual método de pagamento?
          </p>
        </div>
      </div>
      <div class="columns mt-4-mobile">
        <div class="column is-full">
          <div class="buttons is-flex is-flex-direction-column is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 is-size-5-mobile has-text-weight-bold mx-6 mx-2-mobile my-2 is-four-fifths"
                @click.prevent="generatePaymentByCreditCard"
            >
              <div class="button-content">
                <span class="button-text">Cartão em {{ formData.plan.data.seasonality }} X</span>
                <font-awesome-icon
                    icon="fa-solid fa-credit-card"
                    class="ml-4"
                    size="1x"
                />
              </div>
            </button>
            <button
              class="button is-grey is-size-3 is-size-5-mobile has-text-weight-bold mx-4 mx-2-mobile my-2 is-four-fifths"
              @click.prevent="generatePaymentByBankBillet"
              :disabled="AppStoreStore && AppStoreStore.loading"
            >
              <span v-if="formData.plan.data.seasonality === 12">Boleto - 8% Desconto</span>
              <div class="button-content">
                <span class="button-text">Boleto</span>
                <font-awesome-icon
                  icon="fa-solid fa-barcode"
                  class="ml-4"
                  size="1x"
                />
              </div>
            </button>
          </div>
          <div class="is-flex is-justify-content-center is-full">
            <flash-message></flash-message>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import orderApi from '@/apis/orders'
import { useAppStore } from "@/stores/AppStore";
import { mapStores } from 'pinia'

export default {

  name: 'payment-method',

  data() {
    return {
      isMobile: false
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapStores(useAppStore)
  },

  methods: {
    async generatePaymentByBankBillet() {
      if (this.AppStoreStore) {
        this.AppStoreStore.loading = true;
      }
      
      try {
        const customer = this.formData.customer.data
        const orderData = {
          status: 1,
          customer_id: customer.id,
          plan_id: this.formData.plan.data.id,
          partner_id: this.formData.partner.data.id,
          message_packet_id: this.formData.messagePacket.data.id,
          quantity_message_packets: this.formData.messagePacket.data.quantity,
          is_api_cloud: this.formData.messagePacket.isApiCloud,
          extraServicePlans: [],
          seller_name: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno',
          paymentProfile: {
            payment_method_code: 'bank_slip'
          }
        }

        if (this.formData.orderManagement && this.formData.orderManagement.data && this.formData.orderManagement.data.id) {
          orderData.extraServicePlans.push({
            id: this.formData.orderManagement.data.extraServicePlans[0].id,
            quantity: 1
          })
        }

        if (this.formData.recoverBannedChip && this.formData.recoverBannedChip.data && this.formData.recoverBannedChip.data.id) {
          orderData.extraServicePlans.push({
            id: this.formData.recoverBannedChip.data.extraServicePlans[0].id,
            quantity: 1
          })
        }

        if (this.formData.extraChips && this.formData.extraChips.data && this.formData.extraChips.data.id && this.formData.extraChips.data.quantity > 1) {
          orderData.extraServicePlans.push({
            id: this.formData.extraChips.data.extraServicePlans[0].id,
            quantity: (this.formData.extraChips.data.quantity - 1)
          })
        }

        if (this.formData.extraAccesses && this.formData.extraAccesses.data && this.formData.extraAccesses.data.id && 
            this.formData.extraAccesses.data.quantity > this.formData.plan.data.max_accesses) {
          orderData.extraServicePlans.push({
            id: this.formData.extraAccesses.data.extraServicePlans[0].id,
            quantity: (this.formData.extraAccesses.data.quantity - this.formData.plan.data.max_accesses)
          })
        }

        if (this.formData.extraServices && this.formData.extraServices.data && this.formData.extraServices.data.length > 0) {
          for (const extraService of this.formData.extraServices.data) {
            orderData.extraServicePlans.push({
              id: extraService.extraServicePlans[0].id,
              quantity: extraService.quantity
            })
          }
        }

        const order = await orderApi.create(orderData);
        if (order.integrationData && order.integrationData.bill && 
            order.integrationData.bill.charges[0].last_transaction.gateway_response_code !== null) {
          this.$flashStorage.destroyAll()
          if (this.$flashStorage && typeof this.flashError === 'function') {
            this.flashError(order.integrationData.bill.charges[0].last_transaction.gateway_message);
          } else {
            console.error(order.integrationData.bill.charges[0].last_transaction.gateway_message);
          }
          return;
        }
        const appStore = useAppStore()
        appStore.orderFormData = this.formData
        appStore.order = order
        appStore.orderType = 'bank_billet'
        await this.$router.push({ path: '/billet', query: {
          vendedor: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno'
        } })
      } catch (error) {
        console.error("Erro ao gerar boleto:", error);
        if (this.$flashStorage) {
          this.$flashStorage.flash({
            message: 'Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.',
            type: 'error',
            time: 5000
          });
        }
      } finally {
        if (this.AppStoreStore) {
          this.AppStoreStore.loading = false;
        }
      }
    },
    
    async generatePaymentByCreditCard() {
      const appStore = useAppStore()
      appStore.orderFormData = this.formData
      appStore.orderType = 'credit_card'
      await this.$router.push({ path: '/payment', query: {
        vendedor: this.$route.query.vendedor ? this.$route.query.vendedor : 'interno',
        modalidade: 'cartao'
      } })
    },
    
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  },
  
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  }
}

</script>

<style lang="scss" scoped>
.payment-method-component {
  button {
    transition: all 0.3s ease;
    overflow: hidden;
    
    &:hover:not(:disabled) {
      transform: translateY(-3px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    
    .button-content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .payment-method-component {
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-5-mobile {
      font-size: 1rem !important;
    }
    
    .mt-4-mobile {
      margin-top: 1rem !important;
    }
    
    .mx-2-mobile {
      margin-left: 0.5rem !important;
      margin-right: 0.5rem !important;
    }
    
    button {
      padding: 1rem !important;
      height: auto !important;
      
      .button-content {
        flex-direction: row;
        justify-content: space-between;
      }
      
      svg {
        font-size: 1.2rem !important;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .payment-method-component {
    button {
      padding: 0.75rem !important;
      
      .button-text {
        font-size: 0.9rem !important;
      }
      
      svg {
        font-size: 1rem !important;
      }
    }
  }
}
</style>
